var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Padlock.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Padlock = ({
  color = '#D9575E',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("g", {
    clipPath: "url(#clip0_306_97765)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.5312 5.5H10.9219V4.35714C10.9219 2.78 9.55688 1.5 7.875 1.5C6.19313 1.5 4.82812 2.78 4.82812 4.35714V5.5H4.21875C3.54844 5.5 3 6.01429 3 6.64286V12.3571C3 12.9857 3.54844 13.5 4.21875 13.5H11.5312C12.2016 13.5 12.75 12.9857 12.75 12.3571V6.64286C12.75 6.01429 12.2016 5.5 11.5312 5.5ZM6.04688 4.35714C6.04688 3.40857 6.86344 2.64286 7.875 2.64286C8.88656 2.64286 9.70312 3.40857 9.70312 4.35714V5.5H6.04688V4.35714ZM7.875 10.6429C8.54531 10.6429 9.09375 10.1286 9.09375 9.5C9.09375 8.87143 8.54531 8.35714 7.875 8.35714C7.20469 8.35714 6.65625 8.87143 6.65625 9.5C6.65625 10.1286 7.20469 10.6429 7.875 10.6429Z",
      fill: color
    })
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_306_97765",
      children: /*#__PURE__*/_jsx("rect", {
        width: "15",
        height: "15",
        fill: "white"
      })
    })
  })]
});